import React from 'react';
import BinaryHotel from './components/BinaryHotel';
import './App.css';

function App() {
  return (
    <div className="App">
      <h1>Binary Hotel</h1>
      <BinaryHotel />
    </div>
  );
}

export default App; 